export const TABLE_SETTINGS = {
    manualPagination: true,
    manualFiltering: true,
    manualSorting: true,
    enableGlobalFilter: false,
    enableHiding: false,
};

export const PAGINATION_INITIAL_STATE = {
    pageIndex: 0,
    pageSize: 5,
};

export const COLUMN_FILTERS_INITIAL_STATE = [];

export const SORTING_INITIAL_STATE = [];
